import React, { useState } from 'react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { toast } from 'sonner';

export const ManualApproveDialog = ({ timesheet, token, apiCall, onDone }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [designation, setDesignation] = useState('');
  const [notes, setNotes] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!name.trim() || !designation.trim()) {
      toast.error('Approver name and designation are required');
      return;
    }
    setBusy(true);
    try {
      await apiCall(`/timesheets/${timesheet.id}/manual-approve`, 'POST', {
        approver_name: name,
        approver_designation: designation,
        notes: notes || null,
      }, token);
      toast.success('Timesheet approved without signature — approver recorded');
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(e.detail || 'Failed to approve timesheet');
    }
    setBusy(false);
  };

  return (
    <>
      <Button size="sm" variant="outline" className="border-amber-400 text-amber-700 hover:bg-amber-50"
        onClick={() => setOpen(true)} data-testid={`manual-approve-btn-${timesheet.id}`}>
        Manual Approve
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Approve without signature</DialogTitle>
            <DialogDescription>
              Use this when the staff member couldn't get the timesheet signed on shift. Record who at the client
              authorised it (e.g. by phone or email). The timesheet will be clearly flagged "Approved without signature".
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div>
              <Label>Client approver name *</Label>
              <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Sarah Jones" data-testid="manual-approver-name" />
            </div>
            <div>
              <Label>Designation *</Label>
              <Input value={designation} onChange={(e) => setDesignation(e.target.value)} placeholder="e.g. Home Manager" data-testid="manual-approver-designation" />
            </div>
            <div>
              <Label>Notes (how approval was obtained)</Label>
              <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={2} placeholder="e.g. Confirmed by phone on 06/10/2026" data-testid="manual-approve-notes" />
            </div>
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
              <Button className="bg-amber-600 hover:bg-amber-700" disabled={busy || !name.trim() || !designation.trim()}
                onClick={submit} data-testid="manual-approve-submit">
                Approve without signature
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
